var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOpenReverse(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.96767 8.38573C4.72519 8.18573 4.72519 7.81426 4.96767 7.61427L8.93186 4.34467C9.25798 4.07569 9.75 4.30766 9.75 4.73039L9.75 11.2696C9.75 11.6923 9.25798 11.9243 8.93186 11.6553L4.96767 8.38573Z",
    fill: "#4050A6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOpenReverse);
export default __webpack_public_path__ + "static/media/open_reverse.4cd78ac31893b8e8f18dd9ce7e91a352.svg";
export { ForwardRef as ReactComponent };